/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CardOrderQueryRequestDto,
  InfiniteScrollListCardOrderDtoCardOrderResponseMetadata,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiCardOrderController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-card-order-controller
   * @name GetCardOrders
   * @request POST:/api/v1/card-orders/paged
   */
  getCardOrders = (data: CardOrderQueryRequestDto, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCardOrderDtoCardOrderResponseMetadata, any>({
      path: `/v1/card-orders/paged`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getCardOrdersPath = '/v1/card-orders/paged'
  static getCardOrdersMethod = 'POST'
}
